import axios from 'axios'
import getHeaders from '../helpers/headers'
import { getError } from 'api/helpers'
import config from '../../constants/endpoints.js'

const createVa = (data) => axios({
  method: 'post',
  url: config.endpoints.botConsole.newVa,
  data,
  headers: getHeaders(true)
}).catch(error => {
  throw getError(error)
})

const getVaList = () => axios({
  method: 'get',
  url: config.endpoints.botConsole.vaList,
  headers: getHeaders(true)
})

const getBotHeader = (botId) => axios({
  method: 'get',
  url: config.endpoints.botConsole.botHeader.replace(':botId', botId),
  headers: getHeaders(true)
})

const updateBotHeader = (botId, data) => axios({
  method: 'put',
  url: config.endpoints.botConsole.botHeader.replace(':botId', botId),
  data: data,
  headers: getHeaders(true)
}).catch(error => {
  throw getError(error)
})

const deleteBot = (botId) => axios({
  method: 'delete',
  url: config.endpoints.botConsole.botHeader.replace(':botId', botId),
  headers: getHeaders(true)
})

const trainBot = (botId) => axios({
  method: 'post',
  url: config.endpoints.botConsole.trainBot.replace(':botId', botId),
  headers: getHeaders(true)
})

const getIntents = (botId) => axios({
  method: 'get',
  url: config.endpoints.botConsole.intents.replace(':botId', botId),
  headers: getHeaders(true)
})

const getIntentDetail = (botId, intentId) => axios({
  method: 'get',
  url: config.endpoints.botConsole.intentDetails.replace(':botId', botId).replace(':intentId', intentId),
  headers: getHeaders(true)
})

const saveIntent = (botId, data) => axios({
  method: 'post',
  url: config.endpoints.botConsole.intents.replace(':botId', botId),
  data,
  headers: getHeaders(true)
})

const updateIntent = (botId, intentId, data) => axios({
  method: 'put',
  url: config.endpoints.botConsole.intent.replace(':botId', botId).replace(':intentId', intentId),
  data,
  headers: getHeaders(true)
})

const deleteIntent = (botId, intentId) => axios({
  method: 'delete',
  url: config.endpoints.botConsole.intent.replace(':botId', botId).replace(':intentId', intentId),
  headers: getHeaders(true)
})

const updateIntentStatus = (botId, intentId, data) => axios({
  method: 'put',
  url: config.endpoints.botConsole.intentStatus.replace(':botId', botId).replace(':intentId', intentId),
  data,
  headers: getHeaders(true)
})

const getSetting = (data) => axios({
  method: 'post',
  url: config.endpoints.botConsole.setting,
  data,
  headers: getHeaders(true)
})

const getSmartChatHealth = (botId) => axios({
  method: 'get',
  url: config.endpoints.botConsole.smartChatHealth.replace(':botId', botId),
  headers: getHeaders(true)
})

export default {
  createVa,
  getVaList,
  getBotHeader,
  updateBotHeader,
  deleteBot,
  trainBot,
  getIntents,
  getIntentDetail,
  saveIntent,
  updateIntent,
  deleteIntent,
  updateIntentStatus,
  getSetting,
  getSmartChatHealth
}
